import axios from 'axios';
import { Usuario } from '../shared/model/usuario';

const { REACT_APP_ESTEIRA_BACK } = process.env;

export default class UsuarioExternoService {
  axios: any;
  constructor() {
    this.axios = axios.create({
      baseURL: REACT_APP_ESTEIRA_BACK + '/api/usuarioControllerExterno'
    })
  }

  async login(dados: any) {
    const { data } = await this.axios.post('/login', dados);

    if (data) {
      localStorage.setItem("nome", data.nome);
      localStorage.setItem("role", data.role);
      localStorage.setItem("token", data.token);
      localStorage.setItem("id", data.id);

      return data;
    }
    return;
  };

  usuarioAutenticado() {
    return localStorage.getItem("token") !== undefined && localStorage.getItem("token") !== null ? true : false;
  };

  async logout() {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          await this.axios.post('/logout', {}, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
        } catch (error) {
          console.error("Erro ao invalidar token no servidor (pode já estar expirado):", error);
        }
      }

      localStorage.removeItem("nome");
      localStorage.removeItem("role");
      localStorage.removeItem("token");
      localStorage.removeItem("id"); 
  }

  async alterarSenha(dto: Usuario) {
    return await this.axios.post(`/alterarSenha`, dto);
  };

  async listarTodosOriginadoresAtivos() {
    return await this.axios.get(`/listarTodosOriginadoresAtivos`);
  };

  async listarUsuarioComOrigemPorUsuario(usuario: string) {
    return await this.axios.get(`/listarUsuarioComOrigemPorUsuario?usuario=${usuario}`);
  };

}